import { useState } from 'react';
import { faqData } from '@/mocks/faq';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <div className="flex items-center justify-center gap-2 mb-2">
            <i className="ri-question-answer-line text-primary-500 text-lg"></i>
            <span className="text-xs font-medium text-primary-600 bg-primary-100 px-2.5 py-1 rounded-full whitespace-nowrap">常见问题</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
            关于99漫画的常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            快速了解99漫画平台，找到你想知道的一切
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="font-medium text-sm text-foreground-900 pr-4">{faq.question}</span>
                <div className={`w-6 h-6 flex-shrink-0 flex items-center justify-center transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4 transition-all duration-300 ease-out">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}